import React, { createContext, useContext, ReactNode } from 'react';

// Create an empty context to replace the demo mode functionality
interface DemoModeContextType {
  // Empty interface - no demo mode functionality
}

const DemoModeContext = createContext<DemoModeContextType | undefined>(undefined);

export const useDemoMode = () => {
  const context = useContext(DemoModeContext);
  if (context === undefined) {
    throw new Error('useDemoMode must be used within a DemoModeProvider');
  }
  return context;
};

export const DemoModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Empty provider that just renders children
  return <DemoModeContext.Provider value={{}}>{children}</DemoModeContext.Provider>;
};